import ProtocoloProcessosUGComponent from "../views/processo-eletronico/protocolos-processos/protocolos-processos-ug.vue";
import ProtocoloProcessosMeusProtocolosProcessosComponent from "../views/processo-eletronico/protocolos-processos/meus-protocolos-processos.vue";
import ProtocoloProcessosConsultaAdvogadoComponent from "../views/processo-eletronico/protocolos-processos/consulta-advogado.vue";
import ProtocoloProcessosConsultaAdminComponent from "../views/processo-eletronico/protocolos-processos/consulta-admin.vue";
import DetalheProtocoloProcesso from "../views/processo-eletronico/protocolos-processos/detalhe-protocolo-processo.vue";
import ComunicacoesEletronicas from "../views/processo-eletronico/comunicacoes-eletronicas/ComunicacoesEletronicas.vue";
import DetalhesComunicacaoEletronica from "../views/processo-eletronico/comunicacoes-eletronicas/DetalhesComunicacaoEletronica.vue";
import ResponderComunicacaoEletronica from "../views/processo-eletronico/comunicacoes-eletronicas/ResponderComunicacaoEletronica.vue";
import MeusRecibos from "../views/processo-eletronico/MeusRecibos.vue";
import CriarProtocolo from "@/views/processo-eletronico/protocolos-processos/CriarProtocolo.vue";
import SolicitacoesAssinatura from "../views/processo-eletronico/SolicitacoesAssinatura.vue";
import DetalhesSolicitacaoAssinatura from "../views/processo-eletronico/DetalhesSolicitacaoAssinatura.vue";
import HistoricoSolicitacoesAssinatura from "../views/processo-eletronico/HistoricoSolicitacoesAssinatura.vue";
import Decisoes from "@/views/processo-eletronico/Decisoes.vue";

const processoEletronicoRotas = [
  {
    path: "/processo-eletronico/protocolos-processos-ug",
    name: "protocolos-processos-ug",
    component: ProtocoloProcessosUGComponent,
  },
  {
    path: "/processo-eletronico/detalhe-protocolo-processo",
    name: "detalhe-protocolo-processo",
    component: DetalheProtocoloProcesso,
    props: { item: null },
  },
  {
    path: "/processo-eletronico/meus-protocolos-processos",
    name: "meus-protocolos-processos",
    component: ProtocoloProcessosMeusProtocolosProcessosComponent,
  },
  {
    path: "/processo-eletronico/consulta-advogado",
    name: "consulta-advogado",
    component: ProtocoloProcessosConsultaAdvogadoComponent,
  },
  {
    path: "/processo-eletronico/consulta-admin",
    name: "consulta-admin",
    component: ProtocoloProcessosConsultaAdminComponent,
  },
  {
    path: "/criarProtocolo",
    name: "criarProtocolo",
    component: CriarProtocolo,
  },
  {
    path: "/processo-eletronico/comunicacoes-eletronicas",
    name: "comunicacoes-eletronicas",
    component: ComunicacoesEletronicas,
  },
  {
    path: "/processo-eletronico/detalhes-comunicacoes-eletronicas",
    name: "detalhes-comunicacao-eletronica",
    props: true,
    component: DetalhesComunicacaoEletronica,
  },
  {
    path: "/processo-eletronico/responder-comunicacao-eletronica",
    name: "ResponderComunicacaoEletronica",
    props: true,
    component: ResponderComunicacaoEletronica,
  },
  {
    path: "/processo-eletronico/decisoes",
    name: "decisoes",
    component: Decisoes,
  },
  {
    path: "/processo-eletronico/meus-recibos",
    name: "meus-recibos",
    component: MeusRecibos,
  },
  {
    path: "/processo-eletronico/solicitacoes-assinatura",
    name: "processo-eletronico--solicitacoes-assinatura",
    component: SolicitacoesAssinatura,
  },
  {
    path: "/processo-eletronico/detalhes-solicitacao-assinatura",
    name: "processo-eletronico--detalhes-solicitacao-assinatura",
    props: true,
    component: DetalhesSolicitacaoAssinatura,
  },
  {
    path: "/processo-eletronico/historico-solicitacoes-assinatura",
    name: "processo-eletronico--historico-solicitacoes-assinatura",
    component: HistoricoSolicitacoesAssinatura,
  },
];

export { processoEletronicoRotas };
